import { useSelector } from 'react-redux';
import { FUEL_TYPE_MAP } from '../docs/constants';
// DMV: Vehicle Type was echoed raw out of redux here, so a VIN-decoded
// pickup read "Truck" on Refi-Docs while Fees read "Pickup Truck" for the
// same LT quote. Resolve it through the shared label table instead — see
// utility/vehicleTypeLabel.js.
import { vehicleTypeLabel } from '../utility/vehicleTypeLabel';
import { selectRefiDocsFormData} from '../../redux-state/selectors';

function VehicleInfoRefiDoc() {
  const refiDocsFormData = useSelector(selectRefiDocsFormData)

  const getFullFuelType = (input) => {
    return FUEL_TYPE_MAP[input] || input;
  }

  const fuelType = getFullFuelType(refiDocsFormData?.fuelType)

  return (
    <>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Vehicle Information <span className='text-xs text-gray-600 font-normal ml-1'>{refiDocsFormData?.vinCode}</span>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {refiDocsFormData?.vehicleType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Vehicle Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {vehicleTypeLabel(refiDocsFormData?.vehicleType)}
              </div>
            </div>
          }

          {refiDocsFormData?.modelYear &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Model Year:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.modelYear}
              </div>
            </div>
          }

          {refiDocsFormData?.model &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Model:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.model}
              </div>
            </div>
          }

          {refiDocsFormData?.numberOfAxles &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Number of Axles:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.numberOfAxles}
              </div>
            </div>
          }

          {refiDocsFormData?.fuelType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Fuel Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {fuelType}
              </div>
            </div>
          }

          {refiDocsFormData?.odometer &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
               Odometer (miles):
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.odometer).toLocaleString()}
              </div>
            </div>
          }

          {refiDocsFormData?.color &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Color:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.color}
              </div>
            </div>
          }

          {refiDocsFormData?.gvw &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                GVW:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.gvw).toLocaleString()} lbs
              </div>
            </div>
          }

          {refiDocsFormData?.horsepower &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Horsepower:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.horsepower).toLocaleString()}
              </div>
            </div>
          }
        </div>

        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {refiDocsFormData?.condition &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Condition:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.condition}
              </div>
            </div>
          }

          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              Make:
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {refiDocsFormData?.make}
            </div>
          </div>

          {refiDocsFormData?.bodyStyle &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Body Style:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.bodyStyle}
              </div>
            </div>
          }

          {refiDocsFormData?.numberOfTires &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Number of Tires:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.numberOfTires}
              </div>
            </div>
          }

          {refiDocsFormData?.cylinders &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Cylinders:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.cylinders}
              </div>
            </div>
          }

          {refiDocsFormData?.rimSize &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Rim Size (Inches):
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {refiDocsFormData?.rimSize}
              </div>
            </div>
          }

          {refiDocsFormData?.vehicleWeight &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Vehicle Weight:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
              {Number(refiDocsFormData?.vehicleWeight).toLocaleString()} lbs
              </div>
            </div>
          }

          {refiDocsFormData?.mpg &&
          <div className='flex flex-row justify-between gap-2 items-start'>
            <div>
              MPG (Average):
            </div>
            <div className='font-medium text-right break-words min-w-0'>
              {Number(refiDocsFormData?.mpg).toLocaleString()}
            </div>
          </div>
          }

          {refiDocsFormData?.msrp &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                MSRP:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(refiDocsFormData?.msrp || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default VehicleInfoRefiDoc